import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Pagination from 'react-js-pagination';
import { getOrder } from '../../../../actionCreators/order';
import { getOrders } from '../../../../actionCreators/myAccount';
import { logoutUser } from '../../../../actionCreators/auth';
import OrderListing from './OrderListing';
import OrderDetail from './OrderDetail';
import BlankLoader from '../../../components/Common/BlankLoader';
import BootstrapSuccessError from './../BootstrapSuccessError';
import GupshupWhatsapp from '../../../../CommonComponents/GupshupWhatsapp';
import './MyDashboard.scss';
import getSetCookie from '../../../../cookie';

// default pageSize
let pageSize = 5;

class MyDashboard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      selectedOrder: null,
      isOrderDetails: false,
    };
    const { redisCommonData } = this.props;
    const WHATSAPP_OPTIN =
      (redisCommonData &&
        redisCommonData.WHATSAPP_OPTIN &&
        JSON.parse(redisCommonData.WHATSAPP_OPTIN)) ||
      {};
    this.whatsappOptin = WHATSAPP_OPTIN.Desktop?.OrderList || {};
    pageSize = (redisCommonData && redisCommonData.ORDER_LISTING_PAGESIZE_DESKTOP) || pageSize;
    this.activePage = 1;
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    const { ordersList, getOrders, register, match, getOrder } = this.props;
    window.scrollTo(0, 0);
    const pageNumber = window.sessionStorage.getItem('orderActivePage')
      ? parseInt(window.sessionStorage.getItem('orderActivePage'), pageSize)
      : 0;
    this.activePage = pageNumber;
    if (!ordersList) {
      const pager = pageNumber <= 1 ? 0 : pageNumber - 1;
      getOrders(pager, pageSize);
      window.sessionStorage.removeItem('orderActivePage');
    } else {
      this.activeCurrentPage();
    }
    if (match?.url?.indexOf('/customer/account/order-detail/') === 0) {
      getOrder({ orderId: match.params.id, dontInitSession: true, isMyAcct: true });
    }
    if (window.dtm.LenskartRewamp && window.dtm.LenskartRewamp.myaccount) {
      window.dtm.LenskartRewamp.myaccount.OnLoad({
        pagename: 'account dashboard',
        satellite: 'account',
        subSection1: 'account dashboard',
        hierarchy1: 'account dashboard',
        registrationType: register ? 'register' : 'login',
      });
    }
  }
  componentDidUpdate(prevProps) {
    const { ordersList, match, location, orderDetails } = this.props;
    if (
      match &&
      match.params.id &&
      prevProps.orderDetails !== orderDetails &&
      orderDetails &&
      orderDetails.result
    ) {
      (() =>
        this.setState({
          selectedOrder: orderDetails?.result?.orders
            ? orderDetails?.result?.orders[0]
            : orderDetails?.result,
          isOrderDetails: true,
        }))();
    }
    if (match && !match.params.id && prevProps.ordersList !== ordersList && ordersList) {
      this.activeCurrentPage();
    }
    if (match && prevProps.location.pathname !== location.pathname) {
      if (!match.params.id) {
        (() => {
          this.setState({ isOrderDetails: false });
        })();
        this.activeCurrentPage();
        window.scrollTo(0, 0);
      } else if (ordersList && !this.state.isOrderDetails) {
        (() => {
          this.setState({ isOrderDetails: true });
        })();
      }
    }
  }
  activeCurrentPage() {
    this.setState({ activePage: this.activePage ? this.activePage : 1 });
  }
  handlePageChange(pageNumber) {
    if (this.activePage !== pageNumber) {
      const pager = pageNumber <= 1 ? 0 : pageNumber - 1;
      this.props.getOrders(pager, pageSize);
      this.activePage = pageNumber;
      window.sessionStorage.setItem('orderActivePage', pageNumber);
      window.scrollTo(0, 0);
    }
  }

  goToOrderDetails(orderID, reload) {
    const { ordersList, history } = this.props;
    const getOrderId = parseInt(orderID, 10);
    const curOrder = ordersList.filter(order => order.id === getOrderId);
    this.setState({
      selectedOrder: curOrder[0],
      isOrderDetails: true,
    });
    if (!reload) {
      history.push(`/customer/account/order-detail/${orderID}`);
    }
  }
  render() {
    const {
      ordersList,
      totalOrders,
      userInfo,
      logoutUser,
      redisCommonData,
      history,
      match,
      dataLocale,
      currencyMark,
      localeInfo,
    } = this.props;
    const { selectedOrder, isOrderDetails, activePage } = this.state;
    const { MY_ACCOUNT_DASHBOARD, BACK, LOGOUT, ORDERS_PAGE } = dataLocale;
    return (
      <div className="account-dashboard">
        <Helmet title={MY_ACCOUNT_DASHBOARD} />
        <div className="layout justify-content-between margin-t10 margin-b10">
          <div>
            {isOrderDetails ? (
              <div
                className="no-decoration back-cta fw700 font-medium uppercase text-color-primary margin-t30 inline-block cursor-pointer"
                onClick={() => {
                  if (history && history.push) history.push('/customer/account/');
                }}
              >
                <i
                  aria-hidden="true"
                  className="fa fa-angle-left fw700 fs18 margin-r15 pos-rel"
                ></i>
                {BACK}
              </div>
            ) : (
              localeInfo.countryCode !== 'sg' &&
              this.whatsappOptin?.showWidget &&
              !isOrderDetails &&
              ordersList && <GupshupWhatsapp WHATSAPP_OPTIN={this.whatsappOptin} page="OrderList" />
            )}
          </div>
          <div className="margin-t20">
            <button
              className="btn btn-success fs12 uppercase text-color-white font-bold"
              style={{ backgroundColor: '#3db0a6', letterSpacing: '1.3px', padding: '13px 26px' }}
              onClick={() => {
                sessionStorage.removeItem('orderActivePage');
                logoutUser();
                // eslint-disable-next-line no-self-assign
                window.location.href = window.location.href;
              }}
            >
              {LOGOUT}
            </button>
          </div>
        </div>
        {redisCommonData?.SHOW_SBRT_ORDERS_BUTTON && (
          <div
            style={{
              borderRadius: '12px',
              border: '1px solid #CECEDF',
              padding: '16px 24px',
              boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
              margin: '16px 0',
              backgroundColor: '#fff',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: '8px',
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', maxWidth: '300px' }}
              >
                <img
                  alt=""
                  src="https://static.lenskart.com/media/desktop/img/DesignStudioIcons/sbrtWidgetImage.svg"
                  style={{ width: '42px', height: '32px' }}
                />
                <div>
                  <div className="text-color_grey_black fs16 pd-b4">
                    {dataLocale?.SBRT_WIDGET_TITLE || 'Branded Contact Lens orders'}
                  </div>
                  <p className="text-color-grey fs14 ">
                    {dataLocale?.SBRT_WIDGET_SUBTITLE || 'View orders from these brands'}
                  </p>
                  <img
                    alt=""
                    src={
                      redisCommonData?.SBRT_BRANDS_IMAGE_URL ||
                      'https://static.lenskart.com/media/desktop/img/DesignStudioIcons/sbrtWidgetImage.svg'
                    }
                    style={{ minWidth: '270px', minHeight: '16px', maxHeight: '32px' }}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  className={`${'pd-t8 pd-b8'} btn btn-success text-color-white  text-center bora-4 block cursor-pointer fw700`}
                  style={{ backgroundColor: 'rgb(61, 176, 166)' }}
                  onClick={() => {
                    window.location.href = `${
                      redisCommonData?.SBRT_ORIGIN_DOMAIN_URL || 'https://www.contactskart.com'
                    }/customer/account${
                      getSetCookie.getCookie('isLogined') == '1'
                        ? `?customerNumber=${this.props.userInfo.telephone}`
                        : ''
                    }`;
                  }}
                >
                  {dataLocale?.SBRT_VIEW_BRANDED_CL_ORDERS || 'VIEW ORDERS'}
                </div>
                <span
                  className={`${'fa fa-angle-right'} padding-l16 fs20 text-color-primary cursor-pointer fw700`}
                />
              </div>
            </div>
          </div>
        )}
        {!isOrderDetails && totalOrders !== undefined && totalOrders > pageSize && (
          <div className="layout justify-content-between center">
            <p className="uppercase" style={{ color: '#6d6f71' }}>
              {ORDERS_PAGE}: {activePage}
            </p>
            <Pagination
              activeLinkClass="active-page"
              activePage={activePage}
              itemsCountPerPage={pageSize}
              pageRangeDisplayed={pageSize}
              totalItemsCount={totalOrders}
              onChange={this.handlePageChange}
            />
          </div>
        )}
        {!ordersList && <BlankLoader />}
        {isOrderDetails && !selectedOrder && (
          <BootstrapSuccessError message="No Result Found" timeout="false" type="error" />
        )}
        {!isOrderDetails && activePage && ordersList && (
          <OrderListing
            dataLocale={dataLocale}
            getOrderDetails={orderID => this.goToOrderDetails(orderID, false)}
            history={history}
            ordersList={ordersList}
            redisCommonData={redisCommonData}
            userInfo={userInfo}
          />
        )}
        {isOrderDetails && selectedOrder && (
          <OrderDetail
            currencyMark={currencyMark}
            dataLocale={dataLocale}
            history={history}
            match={match}
            order={this.state.selectedOrder}
            redisCommonData={redisCommonData}
            userInfo={userInfo}
          />
        )}
        {!isOrderDetails && totalOrders !== undefined && totalOrders > pageSize && (
          <div className="layout justify-content-between center full-width">
            <p className="uppercase" style={{ color: '#6d6f71' }}>
              {ORDERS_PAGE}: {activePage}
            </p>
            <Pagination
              activeLinkClass="active-page"
              activePage={activePage}
              itemsCountPerPage={pageSize}
              pageRangeDisplayed={pageSize}
              totalItemsCount={totalOrders}
              onChange={this.handlePageChange}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const ordersList = (state.myAccount.ordersList && state.myAccount.ordersList.orders) || null;
  return {
    ordersList,
    orderDetails: state.order.orderDetails,
    userInfo: state.common.userInfo.result,
    totalOrders: state.myAccount.totalOrders,
    register: state.auth.register,
    loginStatus: state.common.login,
    returnConfig: state.myAccount.returnConfig,
    redisCommonData: state.common.redisCommonData,
    dataLocale: state.locale,
    returnEligibiliyDetailsArr: state.myAccount.returnEligibiliyDetailsArr,
    currencyMark: state.common.currencyMark,
    localeInfo: state.common.localeInfo,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getOrders: (pageName, size) => dispatch(getOrders(pageName, size)),
    logoutUser: () => dispatch(logoutUser()),
    getOrder: data => dispatch(getOrder(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MyDashboard);
